import { Host, h } from '@stencil/core';
import { scrollToDiv } from '../../../utils/utils';
export class AibaRecommendedProducts {
  constructor() {
    this.handleDrawer = event => {
      var _a, _b, _c, _d;
      if (!this.renderForPDF) {
        this.drawerOpen = !this.drawerOpen;
        if (parseInt((_a = this.data) === null || _a === void 0 ? void 0 : _a.limit) > 0) {
          const productsList = (_c = (_b = this.recommendedProductsWrapperRef) === null || _b === void 0 ? void 0 : _b.querySelectorAll('aiba-product')) !== null && _c !== void 0 ? _c : [];
          const productsListArray = Array.from(productsList);
          const limit = (_d = this.data) === null || _d === void 0 ? void 0 : _d.limit;
          if (this.drawerOpen) {
            productsListArray && productsListArray[limit] && scrollToDiv(productsListArray[limit]);
          }
          else {
            productsListArray && productsListArray[0] && scrollToDiv(productsListArray[0]);
          }
        }
        this.handlers && this.handlers.handleRecommendedProductsDrawer && this.handlers.handleRecommendedProductsDrawer(event);
      }
    };
    this.getTagsListForProduct = data => {
      var _a, _b;
      let productList = [];
      (_b = (_a = this.data) === null || _a === void 0 ? void 0 : _a.list) === null || _b === void 0 ? void 0 : _b.map(el => { var _a, _b; return productList.push(h("aiba-product", { detail: el, isMikMakEnabled: (_a = this.data) === null || _a === void 0 ? void 0 : _a.isMikMakEnabled, isBinEnabled: (_b = this.data) === null || _b === void 0 ? void 0 : _b.isBinEnabled, data: data, handlers: this.handlers })); });
      return productList;
    };
    this.renderProductsFromArrayOfTabObjects = (tabsWithProductDataObj, data) => {
      var _a;
      const tabName = data._id;
      const tabData = tabsWithProductDataObj[tabName];
      const wholeData = Object.assign({}, data);
      wholeData['list'] = [...tabData];
      return (_a = wholeData === null || wholeData === void 0 ? void 0 : wholeData.list) === null || _a === void 0 ? void 0 : _a.map(el => {
        var _a;
        return (h("aiba-product", { detail: el, isMikMakEnabled: (_a = this.data) === null || _a === void 0 ? void 0 : _a.isMikMakEnabled, isBinEnabled: wholeData === null || wholeData === void 0 ? void 0 : wholeData.isBinEnabled, data: data, handlers: this.handlers }));
      });
    };
    this.styles = undefined;
    this.data = undefined;
    this.renderForPDF = false;
    this.pdfProductsList = undefined;
    this._id = undefined;
    this.handlers = undefined;
    this.drawerOpen = false;
    this.carouselData = undefined;
    this.tabsWithProductDataObj = undefined;
    this.modalData = undefined;
    this.showModal = false;
  }
  updateRecommendedProducts(event) {
    if (!this.renderForPDF) {
      const res = event.detail ? event.detail : '';
      const data = this.data;
      if (res === null || res === void 0 ? void 0 : res.data) {
        this.tabsWithProductDataObj = res === null || res === void 0 ? void 0 : res.data;
      }
      else {
        this.data = Object.assign(Object.assign({}, data), { list: res });
      }
    }
  }
  async productModalHandler(event) {
    var _a;
    let data;
    ((_a = this.handlers) === null || _a === void 0 ? void 0 : _a.infoClickHandler) ? (data = await this.handlers.infoClickHandler(event)) : (data = event.detail.data);
    this.modalData = data;
    this.showModal = true;
  }
  closeModal(event) {
    var _a, _b;
    this.showModal = false;
    ((_a = this.handlers) === null || _a === void 0 ? void 0 : _a.infoCloseClickHandler) && ((_b = this.handlers) === null || _b === void 0 ? void 0 : _b.infoCloseClickHandler(event, this.recommendedProductsWrapperRef));
  }
  async componentWillLoad() {
    if (this.handlers && this.handlers.handleRecommendedProductsOnLoad && !this.renderForPDF) {
      this.data = await this.handlers.handleRecommendedProductsOnLoad(this.data);
    }
  }
  renderProductListPreConditions(element, type) {
    switch (type) {
      case 'renderForPDF':
        return this.renderProductList(element['data']);
      case 'renderForBinEnabled':
        return h("aiba-bin-init", { handlers: this.handlers }, this.renderProductList(element['data']));
      case 'renderForBinDisabled':
        return this.renderProductList(element['data']);
    }
  }
  renderProductList(data) {
    var _a, _b, _c, _d, _e;
    if (!this.renderForPDF) {
      return this.carouselData ? (h("div", { class: "recommended-products-inner-wrapper" }, h("aiba-carousel", Object.assign({}, this.carouselData, { handleSliderNext: event => this.handlers && this.handlers.handleProductsSliderNext & this.handlers.handleProductsSliderNext(event), handleSliderPrev: event => this.handlers && this.handlers.handleProductsSliderPrev & this.handlers.handleProductsSliderPrev(event), handlers: this.handlers, children: this.getTagsListForProduct(data) }), this.tabsWithProductDataObj
        ? this.renderProductsFromArrayOfTabObjects(this.tabsWithProductDataObj, this.data)
        : (_b = (_a = this.data) === null || _a === void 0 ? void 0 : _a.list) === null || _b === void 0 ? void 0 : _b.map(el => {
          var _a, _b;
          return (h("aiba-product", { detail: el, isMikMakEnabled: (_a = this.data) === null || _a === void 0 ? void 0 : _a.isMikMakEnabled, isBinEnabled: (_b = this.data) === null || _b === void 0 ? void 0 : _b.isBinEnabled, data: data, handlers: this.handlers }));
        })))) : (h("div", { class: "recommended-products-inner-wrapper" }, this.data.list.slice(0, !this.drawerOpen ? (_c = this.data) === null || _c === void 0 ? void 0 : _c.limit : (_e = (_d = this.data) === null || _d === void 0 ? void 0 : _d.list) === null || _e === void 0 ? void 0 : _e.length).map(el => {
        var _a, _b;
        return (h("aiba-product", { detail: el, isMikMakEnabled: (_a = this.data) === null || _a === void 0 ? void 0 : _a.isMikMakEnabled, isBinEnabled: (_b = this.data) === null || _b === void 0 ? void 0 : _b.isBinEnabled, data: data, handlers: this.handlers }));
      })));
    }
    else {
      return (h("div", { class: "recommended-products-inner-wrapper" }, this.pdfProductsList.map(el => {
        var _a;
        return (h("aiba-product", { detail: el, isMikMakEnabled: (_a = this.data) === null || _a === void 0 ? void 0 : _a.isMikMakEnabled, data: data, handlers: this.handlers }));
      })));
    }
  }
  render() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    if (typeof (this === null || this === void 0 ? void 0 : this.data) === 'string') {
      this.data = JSON.parse(this === null || this === void 0 ? void 0 : this.data);
    }
    return (h(Host, Object.assign({}, (this._id && { id: this._id })), this.styles && h("style", null, this.styles), h("div", { class: "recommended-products-wrapper", ref: el => (this.recommendedProductsWrapperRef = el) }, this.data &&
      (((_b = (_a = this.data) === null || _a === void 0 ? void 0 : _a.list) === null || _b === void 0 ? void 0 : _b.length) > 0 || ((_c = this.pdfProductsList) === null || _c === void 0 ? void 0 : _c.length) > 0) &&
      this.data.elements.map((element, index) => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
        if (element && element['name'] === 'aiba-carousel') {
          this.carouselData = element;
        }
        return (h("div", { class: 'recommended-products-element recommended-products-element' + index }, element && element['name'] === 'aiba-label' && h("aiba-label", Object.assign({}, element['data'])), element && element.name === 'aiba-link' && ((_b = (_a = this.data) === null || _a === void 0 ? void 0 : _a.list) === null || _b === void 0 ? void 0 : _b.length) > ((_c = this.data) === null || _c === void 0 ? void 0 : _c.limit) && (h("div", { class: "aiba-link-wrapper" }, h("aiba-link", { arialabel: this.drawerOpen ? (_d = element === null || element === void 0 ? void 0 : element.data) === null || _d === void 0 ? void 0 : _d.lesstext : (_e = element === null || element === void 0 ? void 0 : element.data) === null || _e === void 0 ? void 0 : _e.moretext, text: this.drawerOpen ? (_f = element === null || element === void 0 ? void 0 : element.data) === null || _f === void 0 ? void 0 : _f.lesstext : (_g = element === null || element === void 0 ? void 0 : element.data) === null || _g === void 0 ? void 0 : _g.moretext, clickEvent: event => this.handleDrawer(event), tabIndex: 0, role: "button", onKeyDown: e => {
            if (e.key === 'Enter') {
              this.handleDrawer(e);
            }
          } }))), ((_h = this.pdfProductsList) === null || _h === void 0 ? void 0 : _h.length) > 0 && this.renderProductListPreConditions(element, 'renderForPDF'), element.name === 'aiba-bin-init' && ((_j = this.data) === null || _j === void 0 ? void 0 : _j.isBinEnabled) && ((_l = (_k = this.data) === null || _k === void 0 ? void 0 : _k.list) === null || _l === void 0 ? void 0 : _l.length) && this.renderProductListPreConditions(element, 'renderForBinEnabled'), element.name === 'aiba-bin-init' && ((_o = (_m = this.data) === null || _m === void 0 ? void 0 : _m.list) === null || _o === void 0 ? void 0 : _o.length) && !((_p = this.data) === null || _p === void 0 ? void 0 : _p.isBinEnabled) && this.renderProductListPreConditions(element, 'renderForBinDisabled'), element.name === 'product-modal' && this.showModal && (element === null || element === void 0 ? void 0 : element.data) && (h("aiba-modal", { modalPosition: "center", handlers: this.handlers, closeButtonData: element.data['closeButtonData'] ? element.data['closeButtonData'] : '', handleClick: event => this.closeModal(event) }, h("div", { class: "product-wrapper__product-modal" }, (_r = (_q = element.data) === null || _q === void 0 ? void 0 : _q.elements) === null || _r === void 0 ? void 0 : _r.map((innerComponent) => {
          var _a, _b;
          if (innerComponent && innerComponent['name'] === 'aiba-label')
            return (h("aiba-label", Object.assign({ text: (innerComponent === null || innerComponent === void 0 ? void 0 : innerComponent.productAttribute) ? this.modalData[innerComponent === null || innerComponent === void 0 ? void 0 : innerComponent.productName] : (_a = this.modalData) === null || _a === void 0 ? void 0 : _a.productName }, innerComponent['data'])));
          if (innerComponent && innerComponent['name'] === 'aiba-description-label') {
            return (h("aiba-label", Object.assign({ text: (innerComponent === null || innerComponent === void 0 ? void 0 : innerComponent.productAttribute) ? this.modalData[innerComponent === null || innerComponent === void 0 ? void 0 : innerComponent.productAttribute] : (_b = this.modalData) === null || _b === void 0 ? void 0 : _b.shortDescription }, innerComponent['data'])));
          }
        }))))));
      }), this.data && ((_e = (_d = this.data) === null || _d === void 0 ? void 0 : _d.emptyState) === null || _e === void 0 ? void 0 : _e.element) && ((_g = (_f = this.data) === null || _f === void 0 ? void 0 : _f.list) === null || _g === void 0 ? void 0 : _g.length) === 0 && (h("div", { class: "recommended-products-empty-wrapper", id: (_j = (_h = this.data) === null || _h === void 0 ? void 0 : _h.emptyState) === null || _j === void 0 ? void 0 : _j._id }, ((_m = (_l = (_k = this.data) === null || _k === void 0 ? void 0 : _k.emptyState) === null || _l === void 0 ? void 0 : _l.element) === null || _m === void 0 ? void 0 : _m.name) === 'aiba-label' && h("aiba-label", Object.assign({}, (_p = (_o = this.data) === null || _o === void 0 ? void 0 : _o.emptyState) === null || _p === void 0 ? void 0 : _p.element['data'])))))));
  }
  static get is() { return "aiba-recommended-products"; }
  static get originalStyleUrls() {
    return {
      "$": ["aiba-recommended-products.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["aiba-recommended-products.css"]
    };
  }
  static get properties() {
    return {
      "styles": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "styles",
        "reflect": false
      },
      "data": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "data",
        "reflect": false
      },
      "renderForPDF": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "render-for-p-d-f",
        "reflect": false,
        "defaultValue": "false"
      },
      "pdfProductsList": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "pdf-products-list",
        "reflect": false
      },
      "_id": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "_id",
        "reflect": false
      },
      "handlers": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "handlers",
        "reflect": false
      }
    };
  }
  static get states() {
    return {
      "drawerOpen": {},
      "carouselData": {},
      "tabsWithProductDataObj": {},
      "modalData": {},
      "showModal": {}
    };
  }
  static get listeners() {
    return [{
        "name": "event-recommended-products-changed",
        "method": "updateRecommendedProducts",
        "target": "window",
        "capture": true,
        "passive": false
      }, {
        "name": "infoButtonClicked",
        "method": "productModalHandler",
        "target": undefined,
        "capture": false,
        "passive": false
      }];
  }
}
//# sourceMappingURL=aiba-recommended-products.js.map
